import React, { useCallback, useState } from "react";
import PropTypes from "prop-types";
import Shadow from "~components/atoms/shadow/shadow";
import { publish } from "../../../event_system";
import * as classes from "./accordion_list.module.scss";
import AccordionItem from "./components/accordion_item/accordion_item";

export default function AccordionList({
  children,
  eventNamespace = "accordion",
}) {
  const [activeIndex, setActiveIndex] = useState(0);

  const handleItemClick = useCallback(
    (index) => {
      setActiveIndex(index);

      if (eventNamespace) {
        publish(`${eventNamespace}_index`, index);
      }
    },
    [eventNamespace]
  );

  return (
    <div className={classes.accordionList}>
      <Shadow>
        {children?.length && (
          <ul className={classes.list}>
            {children.map((child, index) => {
              return (
                <AccordionItem
                  index={index}
                  isActive={activeIndex === index}
                  onClick={handleItemClick}
                  key={child._uid}
                  {...child}
                />
              );
            })}
          </ul>
        )}
      </Shadow>
    </div>
  );
}

AccordionList.defaultProps = {
  eventNamespace: undefined,
};

AccordionList.propTypes = {
  children: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      blok: PropTypes.shape({}),
    })
  ).isRequired,
  eventNamespace: PropTypes.string,
};
